"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toHoursAndMinutes = toHoursAndMinutes;
exports.minutesToHoursAndMinutes = minutesToHoursAndMinutes;
exports.padTo2Digits = padTo2Digits;
exports.dateStringToDate = dateStringToDate;
exports.timeStringToDate = timeStringToDate;
exports.dateTimeStringToDate = dateTimeStringToDate;
exports.toYMD = toYMD;
exports.dateOrEmptyString = dateOrEmptyString;
exports.toYMDOrEmpty = toYMDOrEmpty;
exports.formatDate = formatDate;
exports.formatYmdForDisplay = formatYmdForDisplay;
exports.formatDisplayForYmd = formatDisplayForYmd;
exports.formatDateTime = formatDateTime;
exports.addDays = addDays;
exports.addHours = addHours;
exports.addMinutes = addMinutes;
exports.subtractHours = subtractHours;
exports.subtractMinutes = subtractMinutes;
exports.subtractDays = subtractDays;
exports.isSameDay = isSameDay;
exports.isAfter = isAfter;
exports.isBefore = isBefore;
exports.startOfDay = startOfDay;
exports.endOfDay = endOfDay;
exports.startOfMonth = startOfMonth;
exports.endOfMonth = endOfMonth;
exports.differenceInDays = differenceInDays;
exports.differenceInMinutes = differenceInMinutes;
exports.formatDurationHumanize = formatDurationHumanize;
exports.formatDuration = formatDuration;
exports.parseDate = parseDate;
exports.parseMMDDYYYYDate = parseMMDDYYYYDate;
exports.formatTimeString = formatTimeString;
exports.convertTo24HourFormat = convertTo24HourFormat;
exports.getUnixTimestamp = getUnixTimestamp;
exports.isMinor = isMinor;
exports.isUnder21 = isUnder21;
var date_fns_1 = require("date-fns");
function toHoursAndMinutes(totalMinutes) {
    var minutes = totalMinutes % 60;
    var hours = Math.floor(totalMinutes / 60);
    return "".concat(padTo2Digits(hours), ":").concat(padTo2Digits(minutes));
}
function minutesToHoursAndMinutes(totalMinutes) {
    var minutes = totalMinutes % 60;
    var hours = Math.floor(totalMinutes / 60);
    return { hours: hours, minutes: minutes };
}
function padTo2Digits(num) {
    return num.toString().padStart(2, "0");
}
function dateStringToDate(datestring) {
    // Use date-fns parse function for YYYY-MM-DD format
    var parsedDate = (0, date_fns_1.parse)(datestring, "yyyy-MM-dd", new Date());
    if (!(0, date_fns_1.isValid)(parsedDate)) {
        throw new Error("Invalid date format: ".concat(datestring, ". Expected YYYY-MM-DD format."));
    }
    return parsedDate;
}
function timeStringToDate(timestring) {
    // Use date-fns parse function for HH:mm:ss format
    var parsedDate = (0, date_fns_1.parse)(timestring, "HH:mm:ss", new Date());
    if (!(0, date_fns_1.isValid)(parsedDate)) {
        throw new Error("Invalid time format: ".concat(timestring, ". Expected HH:mm:ss format."));
    }
    return parsedDate;
}
function dateTimeStringToDate(datetimestring) {
    // Use date-fns parse function for YYYY-MM-DD HH:mm:ss format
    var parsedDate = (0, date_fns_1.parse)(datetimestring, "yyyy-MM-dd HH:mm:ss", new Date());
    if (!(0, date_fns_1.isValid)(parsedDate)) {
        throw new Error("Invalid datetime format: ".concat(datetimestring, ". Expected YYYY-MM-DD HH:mm:ss format."));
    }
    return parsedDate;
}
function toYMD(date) {
    return (0, date_fns_1.format)(date, "yyyy-MM-dd");
}
function dateOrEmptyString(datestring) {
    try {
        return dateStringToDate(datestring);
    }
    catch (Error) {
        return "";
    }
}
/**
 * Format a value the user may not have filled in yet as a calendar date.
 *
 * Datepickers hand back a Date once touched but leave the model as "" when empty,
 * and sending a raw Date to the API serializes it as UTC, which can land a day
 * early for anyone west of UTC.
 */
function toYMDOrEmpty(value) {
    return value instanceof Date ? toYMD(value) : value;
}
function formatDate(datestring) {
    var date = parseDate(datestring);
    return (0, date_fns_1.format)(date, "MM/dd/yyyy");
}
function formatYmdForDisplay(dateString) {
    if (!dateString) {
        return "";
    }
    // Tolerate "YYYY-MM-DD HH:mm:ss" by keeping just the date portion.
    var datePart = dateString.split(" ")[0];
    var parsed = (0, date_fns_1.parse)(datePart, "yyyy-MM-dd", new Date());
    if ((0, date_fns_1.isValid)(parsed)) {
        return (0, date_fns_1.format)(parsed, "MM/dd/yyyy");
    }
    return "";
}
function formatDisplayForYmd(dateString) {
    if (!dateString) {
        return "";
    }
    var fromDisplay = (0, date_fns_1.parse)(dateString, "MM/dd/yyyy", new Date());
    if ((0, date_fns_1.isValid)(fromDisplay)) {
        return (0, date_fns_1.format)(fromDisplay, "yyyy-MM-dd");
    }
    // ui-mask="99/99/9999" stores the unmasked 8-digit value in ng-model, so a
    // form submission round-trips through "MMddyyyy" before reaching us.
    if (/^\d{8}$/.test(dateString)) {
        var fromMask = (0, date_fns_1.parse)(dateString, "MMddyyyy", new Date());
        if ((0, date_fns_1.isValid)(fromMask)) {
            return (0, date_fns_1.format)(fromMask, "yyyy-MM-dd");
        }
    }
    // Tolerate "YYYY-MM-DD HH:mm:ss" by keeping just the date portion.
    var datePart = dateString.split(" ")[0];
    var alreadyYmd = (0, date_fns_1.parse)(datePart, "yyyy-MM-dd", new Date());
    if ((0, date_fns_1.isValid)(alreadyYmd)) {
        return (0, date_fns_1.format)(alreadyYmd, "yyyy-MM-dd");
    }
    return "";
}
// Moment.js replacement helpers
function formatDateTime(date, format) {
    var d = typeof date === "string" ? parseDate(date) : date;
    if (!format) {
        return (0, date_fns_1.format)(d, "MM/dd/yyyy");
    }
    // Common format replacements using date-fns
    if (format === "MM/DD/YYYY") {
        return (0, date_fns_1.format)(d, "MM/dd/yyyy");
    }
    if (format === "M/DD/YYYY") {
        return (0, date_fns_1.format)(d, "M/dd/yyyy");
    }
    if (format === "YYYY-MM-DD") {
        return toYMD(d);
    }
    if (format === "MMM DD, YYYY") {
        return (0, date_fns_1.format)(d, "MMM dd, yyyy");
    }
    if (format === "h:mm A" || format === "h:mm a") {
        return (0, date_fns_1.format)(d, "h:mm a");
    }
    if (format === "hh:mm A" || format === "hh:mm a") {
        return (0, date_fns_1.format)(d, "hh:mm a");
    }
    if (format === "MM/DD/YYYY h:mm A" || format === "MM/DD/YYYY h:mm a") {
        return (0, date_fns_1.format)(d, "MM/dd/yyyy h:mm a");
    }
    if (format === "MM/DD/YY h:mm a") {
        return (0, date_fns_1.format)(d, "MM/dd/yy h:mm a");
    }
    if (format === "dddd, MMMM Do, YYYY") {
        return (0, date_fns_1.format)(d, "EEEE, MMMM do, yyyy");
    }
    if (format === "ddd, MM/DD/YYYY") {
        return (0, date_fns_1.format)(d, "EEE, MM/dd/yyyy");
    }
    if (format === "DD") {
        return (0, date_fns_1.format)(d, "dd");
    }
    if (format === "YYYY-MM-DD HH:mm:ss") {
        return (0, date_fns_1.format)(d, "yyyy-MM-dd HH:mm:ss");
    }
    if (format === "HH:mm:ss") {
        return (0, date_fns_1.format)(d, "HH:mm:ss");
    }
    if (format === "HH:mm") {
        return (0, date_fns_1.format)(d, "HH:mm");
    }
    // Fallback to basic formatting
    return (0, date_fns_1.format)(d, "MM/dd/yyyy");
}
function addDays(date, days) {
    var d = typeof date === "string" ? parseDate(date) : date;
    return (0, date_fns_1.addDays)(d, days);
}
function addHours(date, hours) {
    var d = typeof date === "string" ? parseDate(date) : date;
    return (0, date_fns_1.addHours)(d, hours);
}
function addMinutes(date, minutes) {
    var d = typeof date === "string" ? parseDate(date) : date;
    return (0, date_fns_1.addMinutes)(d, minutes);
}
function subtractHours(date, hours) {
    return addHours(date, -hours);
}
function subtractMinutes(date, minutes) {
    return addMinutes(date, -minutes);
}
function subtractDays(date, days) {
    return addDays(date, -days);
}
function isSameDay(date1, date2) {
    var d1 = typeof date1 === "string" ? parseDate(date1) : date1;
    var d2 = typeof date2 === "string" ? parseDate(date2) : date2;
    return (0, date_fns_1.isSameDay)(d1, d2);
}
function isAfter(date1, date2) {
    var d1 = typeof date1 === "string" ? parseDate(date1) : date1;
    var d2 = typeof date2 === "string" ? parseDate(date2) : date2;
    return (0, date_fns_1.isAfter)(d1, d2);
}
function isBefore(date1, date2) {
    var d1 = typeof date1 === "string" ? parseDate(date1) : date1;
    var d2 = typeof date2 === "string" ? parseDate(date2) : date2;
    return (0, date_fns_1.isBefore)(d1, d2);
}
function startOfDay(date) {
    var d = typeof date === "string" ? parseDate(date) : date;
    return (0, date_fns_1.startOfDay)(d);
}
function endOfDay(date) {
    var d = typeof date === "string" ? parseDate(date) : date;
    return (0, date_fns_1.endOfDay)(d);
}
function startOfMonth(date) {
    var d = typeof date === "string" ? parseDate(date) : date;
    return (0, date_fns_1.startOfMonth)(d);
}
function endOfMonth(date) {
    var d = typeof date === "string" ? parseDate(date) : date;
    return (0, date_fns_1.endOfMonth)(d);
}
function differenceInDays(date1, date2) {
    var d1 = typeof date1 === "string" ? parseDate(date1) : date1;
    var d2 = typeof date2 === "string" ? parseDate(date2) : date2;
    return Math.abs((0, date_fns_1.differenceInDays)(d1, d2));
}
function differenceInMinutes(date1, date2) {
    var d1 = typeof date1 === "string" ? parseDate(date1) : date1;
    var d2 = typeof date2 === "string" ? parseDate(date2) : date2;
    return (0, date_fns_1.differenceInMinutes)(d1, d2);
}
function formatDurationHumanize(minutes) {
    var start = new Date();
    var end = addMinutes(start, minutes);
    return (0, date_fns_1.formatDistance)(end, start);
}
function formatDuration(minutes) {
    if (minutes < 60) {
        return "".concat(minutes, "m");
    }
    var hours = Math.floor(minutes / 60);
    var remainingMinutes = minutes % 60;
    return remainingMinutes > 0 ? "".concat(hours, "h ").concat(remainingMinutes, "m") : "".concat(hours, "h");
}
function parseDate(dateString) {
    // Handle various date formats using date-fns
    if (dateString.includes("T")) {
        // ISO format
        var parsed_1 = (0, date_fns_1.parseISO)(dateString);
        if ((0, date_fns_1.isValid)(parsed_1)) {
            return parsed_1;
        }
    }
    if (dateString.includes("-")) {
        // Try YYYY-MM-DD format
        try {
            return dateStringToDate(dateString);
        }
        catch (error) {
            // If it fails, try parsing as ISO
            var parsed_2 = (0, date_fns_1.parseISO)(dateString);
            if ((0, date_fns_1.isValid)(parsed_2)) {
                return parsed_2;
            }
        }
    }
    // Fallback to native Date constructor
    var parsed = new Date(dateString);
    if ((0, date_fns_1.isValid)(parsed)) {
        return parsed;
    }
    throw new Error("Unable to parse date string: ".concat(dateString));
}
function parseMMDDYYYYDate(dateString) {
    // Parse MMDDYYYY format (e.g., "12251990" for December 25, 1990)
    if (dateString.length === 8) {
        var parsedDate = (0, date_fns_1.parse)(dateString, "MMddyyyy", new Date());
        if ((0, date_fns_1.isValid)(parsedDate)) {
            return parsedDate;
        }
    }
    // Fallback to native Date constructor
    var parsed = new Date(dateString);
    if ((0, date_fns_1.isValid)(parsed)) {
        return parsed;
    }
    throw new Error("Unable to parse MMDDYYYY date string: ".concat(dateString));
}
// Convert time string to Date and format as h:mm a
function formatTimeString(timeString) {
    var date = timeStringToDate(timeString);
    return (0, date_fns_1.format)(date, "h:mm a");
}
// Convert 12-hour time format (h:mm or h:mm a) to 24-hour format (HH:mm:ss)
function convertTo24HourFormat(timeString) {
    if (!timeString) {
        return "";
    }
    // Handle case where time might be just "h" format
    var timeStr = timeString;
    if (timeStr && !timeStr.includes(":")) {
        timeStr = timeStr + ":00";
    }
    // Parse the time string - try different formats
    var parsedDate;
    // Try parsing with AM/PM first
    if (timeStr.includes("AM") ||
        timeStr.includes("PM") ||
        timeStr.includes("am") ||
        timeStr.includes("pm")) {
        parsedDate = (0, date_fns_1.parse)(timeStr, "h:mm a", new Date());
    }
    else {
        // Assume 24-hour format if no AM/PM
        parsedDate = (0, date_fns_1.parse)(timeStr, "H:mm", new Date());
    }
    if (!(0, date_fns_1.isValid)(parsedDate)) {
        throw new Error("Invalid time format: ".concat(timeString, ". Expected h:mm or h:mm a format."));
    }
    // Format as HH:mm:ss
    return (0, date_fns_1.format)(parsedDate, "HH:mm:ss");
}
// Get unix timestamp
function getUnixTimestamp(date) {
    var d = typeof date === "string" ? parseDate(date) : date;
    return (0, date_fns_1.getUnixTime)(d);
}
function isMinor(date) {
    if (typeof date === "string") {
        date = parseDate(date);
    }
    var today = new Date();
    var eighteenYearsAgo = new Date(today.getFullYear() - 18, today.getMonth(), today.getDate());
    return (0, date_fns_1.isBefore)(date, eighteenYearsAgo);
}
function isUnder21(date) {
    if (typeof date === "string") {
        date = parseDate(date);
    }
    var today = new Date();
    var twentyOneYearsAgo = new Date(today.getFullYear() - 21, today.getMonth(), today.getDate());
    return (0, date_fns_1.isBefore)(date, twentyOneYearsAgo);
}
